import { CloseFill18Icon } from "@vygruppen/spor-icon-react";
import {
  ChangeEvent,
  ComponentProps,
  forwardRef,
  RefObject,
  useRef,
} from "react";
import {
  InputField,
  InputFieldProps,
} from "shared/components/forms/Inputfield";
import { Flex, IconButton } from "shared/components/Spor";

type SearchInputFieldProps = ComponentProps<typeof InputField> &
  InputFieldProps;

/**
 * This component shows a clear button in the InputField, this is necessary
 * as type="search" no longer shows the clear button in many browsers.
 */
export const SearchInputField = forwardRef<
  HTMLInputElement,
  SearchInputFieldProps
>(({ onChange, value, ...rest }, ref) => {
  const backupRef = useRef<HTMLInputElement>(null);
  const inputRef = (ref ?? backupRef) as RefObject<HTMLInputElement>;
  return (
    <Flex alignItems="center" gap="0">
      <InputField ref={inputRef} value={value} onChange={onChange} {...rest} />
      {value !== "" && (
        <IconButton
          icon={<CloseFill18Icon />}
          aria-label="Fjern søk"
          variant="ghost"
          marginLeft="-33px"
          marginRight="3px"
          minH="30px"
          maxH="30px"
          minW="30px"
          maxW="30px"
          onClick={() => {
            onChange?.({
              target: { value: "" },
            } as ChangeEvent<HTMLInputElement>);
            inputRef.current?.focus();
          }}
        />
      )}
    </Flex>
  );
});
